/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdminUpdateUserReqVo } from './AdminUpdateUserReqVo';
import {
    AdminUpdateUserReqVoFromJSON,
    AdminUpdateUserReqVoFromJSONTyped,
    AdminUpdateUserReqVoToJSON,
    AdminUpdateUserReqVoToJSONTyped,
} from './AdminUpdateUserReqVo';

/**
 * 
 * @export
 * @interface ResponseAdminUpdateUserReqVo
 */
export interface ResponseAdminUpdateUserReqVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseAdminUpdateUserReqVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseAdminUpdateUserReqVo
     */
    message?: string;
    /**
     * 
     * @type {AdminUpdateUserReqVo}
     * @memberof ResponseAdminUpdateUserReqVo
     */
    data?: AdminUpdateUserReqVo;
}

/**
 * Check if a given object implements the ResponseAdminUpdateUserReqVo interface.
 */
export function instanceOfResponseAdminUpdateUserReqVo(value: object): value is ResponseAdminUpdateUserReqVo {
    return true;
}

export function ResponseAdminUpdateUserReqVoFromJSON(json: any): ResponseAdminUpdateUserReqVo {
    return ResponseAdminUpdateUserReqVoFromJSONTyped(json, false);
}

export function ResponseAdminUpdateUserReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseAdminUpdateUserReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : AdminUpdateUserReqVoFromJSON(json['data']),
    };
}

export function ResponseAdminUpdateUserReqVoToJSON(json: any): ResponseAdminUpdateUserReqVo {
    return ResponseAdminUpdateUserReqVoToJSONTyped(json, false);
}

export function ResponseAdminUpdateUserReqVoToJSONTyped(value?: ResponseAdminUpdateUserReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': AdminUpdateUserReqVoToJSON(value['data']),
    };
}

